<div class="one" [formGroup]="SettingForm" fxLayout="column">
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-3">
    <mat-form-field
      appearance="outline"
      class="region-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.COUNTRY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COUNTRY),
      }"
    >
      <mat-label>Country</mat-label>
      <mat-select name="COUNTRY" formControlName="COUNTRY" placeholder="Country">
        @for (val of countryList; track val) {
          <mat-option value="{{ val.LOOKUPGUID }}">{{ val.LOOKUPFULLVALUE }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="region-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CURRENCYSYMBOL),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CURRENCYSYMBOL),
      }"
    >
      <mat-label>Currency</mat-label>
      <mat-select name="CURRENCYSYMBOL" formControlName="CURRENCYSYMBOL" placeholder="Currency">
        @for (val of getDropDownValue.CURRENCYSYMBOL; track val) {
          <mat-option value="{{ val.VALUE }}">
            {{ val.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="region-input1 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TIMEZONE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TIMEZONE),
      }"
    >
      <mat-label>Time Zone</mat-label>
      <mat-select name="TIMEZONE" formControlName="TIMEZONE" placeholder="Unit Size">
        @for (val of timeZoneData; track val) {
          <mat-option value="{{ val.Name }}">{{ val.value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-3">
    <mat-form-field
      appearance="outline"
      class="region-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TAXTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TAXTYPE),
      }"
    >
      <mat-label>Tax Type</mat-label>
      <mat-select name="TAXTYPE" formControlName="TAXTYPE" placeholder="Tax Type">
        @for (val of getDropDownValue.TAXTYPE; track val) {
          <mat-option value="{{ val.VALUE }}">{{ val.DESCRIPTION }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="region-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TAXRATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TAXRATE),
      }"
    >
      <mat-label>Tax Rate</mat-label>
      <input name="TAXRATE" formControlName="TAXRATE" type="number" matInput />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <h3 fxFlex="100" class="py-4 pr-1 text-[14px]">
      Eg : $100.00 Ex-GST + $10.00 GST = $110.00
      <br />
    </h3>
  </div>
  <div class="pt-4">
    <mat-dialog-actions class="popup_ftr justify-end!">
      <button
        id="callApiId"
        class="mainbtn_size"
        matButton="filled"
        [disabled]="isspiner"
        (click)="saveReginSetting()"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
      <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
    </mat-dialog-actions>
  </div>
  <!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <h3 fxFlex="100" class="pr-1">
      In SILQ March 28th, 2014 will be displayed as 28-03-2014.<br> If this is not correct, please change it in Control Panel/Regional Settings
    </h3>
  </div> -->
</div>
